import 'select2';
/**
 * Простой кастомный селект
 */

type settings = {
    changeHandler?: ((params: string) => void) | null
};
export default class CustomSelect {
    private readonly $holder: JQuery;
    private readonly options: settings = {
        changeHandler: null
    };


    constructor($holder: JQuery, settings?: settings) {
        this.$holder = $holder;
        this.options = {
            ...this.options,
            ...settings,
        };

        this.init();
    }

    private init(): void
    {
        const select = this.$holder.select2({
            dropdownParent: this.$holder.parent(),
            width: '100%',
            placeholder: this.getPlaceholder(),
        });

        this.$holder.addClass('init');

        if (this.options.changeHandler) {
            select.on('select2:select', (event) => {
                this.options.changeHandler?.($(event.target).val() as string);
            });
        }

        select.on('select2:open', () => {
            const holder = this.getDropdown();

            if (!holder) {
                return;
            }
        });
    }

    private getDropdown(): HTMLElement | null
    {
        return this.$holder.parent().find('.select2-results__options').get(0) ?? null;
    }

    /**
     * Получить плейсхолдер селекта
     * @private
     */
    private getPlaceholder(): string
    {
        return this.$holder.data('customSelectPlaceholder') as string ?? '';
    }
}
